import firebase from 'firebase';
import { CompetitionChoice } from '../interfaces/Competition';
import { FirebaseBackedListProvider } from './FirebaseBackedListProvider';
import { FirebaseItemResolver } from './translators/FirebaseItemResolver';

/** Read names at their leaf paths, never the full competition subtree. */
export class FirebaseCompetitionSummaryProvider extends FirebaseBackedListProvider<CompetitionChoice> {
    constructor(database: firebase.database.Database, eventID: string) {
        super(database.ref(`events/${eventID}/competitions`), id => new FirebaseItemResolver<CompetitionChoice>(
            id, database.ref(`competitions/${id}/name`), {
                translate: (snapshot, success, failure) => {
                    const name = snapshot.val();
                    if (typeof name === 'string' && name.trim()) success({ id, attributes: { name } });
                    else failure('Division name unavailable');
                },
            }
        ));
    }
}
